module.exports = __webpack_public_path__ + "static/man_set_5youngadult.326f4a3c.svg";